import { render, staticRenderFns } from "./avg_rating_report.vue?vue&type=template&id=0498e53d&"
import script from "./avg_rating_report.vue?vue&type=script&lang=js&"
export * from "./avg_rating_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports